export function track(event: string, params?: Record<string, any>) {
  try {
    const w = window as any
    if (!w || typeof w.gtag !== 'function') return

    w.gtag('event', event, params || {})
  } catch (_err) {
    // no-op
  }
}

// Ceny brutto w PLN wg lookup key ze Stripe — muszą odpowiadać cenom w Pricing.tsx
const PLANS: Record<string, { name: string; price: number }> = {
  pro_monthly: { name: 'Pro miesięczny', price: 12 },
  pro_yearly: { name: 'Pro roczny', price: 119 },
  max_month: { name: 'Max miesięczny', price: 19 },
  max_year: { name: 'Max roczny', price: 189 },
}

// Parametry e-commerce GA4 dla begin_checkout / purchase
export function checkoutParams(lookupKey: string) {
  const plan = PLANS[lookupKey]
  return {
    currency: 'PLN',
    value: plan?.price,
    items: [{ item_id: lookupKey, item_name: plan?.name ?? lookupKey, price: plan?.price, quantity: 1 }],
  }
}

// Stripe po udanej płatności wraca z ?purchase=success&plan=<lookupKey>&session_id=<id>.
// Zwraca parametry zdarzenia purchase i adres bez tych parametrów (żeby odświeżenie nie liczyło zakupu drugi raz).
export function readPurchaseReturn(search: string) {
  const qs = new URLSearchParams(search)
  if (qs.get('purchase') !== 'success') return null

  const plan = qs.get('plan')
  const sessionId = qs.get('session_id')
  qs.delete('purchase')
  qs.delete('plan')
  qs.delete('session_id')

  const rest = qs.toString()
  return {
    params: {
      transaction_id: sessionId ?? undefined,
      ...(plan ? checkoutParams(plan) : { currency: 'PLN', value: undefined }),
    },
    cleanedSearch: rest ? `?${rest}` : '',
  }
}

